import { createSelector } from "@reduxjs/toolkit";
import { User } from "../../entities/user";
import { mapToArray } from "../../helpers";
import { AppState } from "../appState";

const selectUsers = (state: AppState) => state.kronosState.userState.users;
const selectUserSearchMetadata = (state: AppState) =>
  state.kronosState.userState.searchMetadata;
const selectUserFilters = (state: AppState) =>
  state.kronosState.userState.filters;
const selectUserSearchOpen = (state: AppState) =>
  state.kronosState.userState.searchOpen;
const selectSelectedUserID = (state: AppState) =>
  state.kronosState.userState.selectedUserID;
const selectStageUserSelector = (state: AppState) =>
  state.kronosState.userState.stagedUser;
const selectUserLoading = (state: AppState) =>
  state.kronosState.userState.loading;

const selectUserFormOpen = (state: AppState) =>
  state.kronosState.userState.userFormOpen;

export const userFormOpenSelector = createSelector(
  [selectUserFormOpen],
  (s) => s
);

export const userLoadingSelector = createSelector(
  [selectUserLoading],
  (s) => s
);

export const usersSelector = createSelector([selectUsers], (users) =>
  mapToArray(users)
);

export const selectedUserSelector = createSelector(
  [selectUsers, selectSelectedUserID],
  (users, selectedUserID) => {
    if (selectedUserID) return users[selectedUserID];
    return undefined;
  }
);

export const stagedUserSelector = createSelector(
  [selectStageUserSelector],
  (s) => (s ? new User(s) : s)
);

export const selectedUserIDSelector = createSelector(
  [selectSelectedUserID],
  (s) => s
);

export const userSearchOpenSelector = createSelector(
  [selectUserSearchOpen],
  (s) => s
);

export const userSearchMetadataSelector = createSelector(
  [selectUserSearchMetadata],
  (s) => s
);

export const userFiltersSelector = createSelector(
  [selectUserFilters],
  (s) => s
);

export const userSelector = (id?: number) => {
  return createSelector([selectUsers], (users) => {
    if (id) return users[id];
    return undefined;
  });
};
